export const desktopWidth = 560;
export const tabletWidth = 512;
export const CLASS_DETAILS_MODAL_NAME = 'classDetailsModal';
export const CLASS_ID_PARAM = 'classId';
export const SOURCE_PARAM = 'source';
export const LIST_POSITION = 'listPosition';
export const FEATURED_MODULE = 'featuredModule';
export const RANK = 'rank';
export const TOTAL = 'total';
export const CATEGORY_SLUG = 'categorySlug';
export const FROM = 'from';
export const IS_COMPLETED = 'isCompleted';
export const FROM_COMPLETED_PAGE = 'fromCompletedPage';
